<template>
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :value="value"
    @input="(status) => $emit('input', status)"
    :reduce="(status) => status.value"
  />
</template>
<script>
export default {
  name: 'StatusSelect',
  props: {
    value: String,
    id: {
      type: String,
      default: 'status-select',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: {
      type: String,
      default: 'Select a Status',
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getStatusOptions();
  },
  methods: {
    getStatusOptions() {
      this.$complianceDocumentsAPI.getStatusOptions().then((response) => {
        this.options = response.data.status_options.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
  },
};
</script>
